import React, { FC } from 'react';

import { Modal } from '../../../../Partials/Modal';
import { InsuranceFormSubmissionStatus } from '../../../../Utils/types';
import { InsuranceFormState } from '../../Utils/insuranceForm';

import { BookingConfirmationControls } from './BookingConfirmationControls';
import { BookingConfirmationSummary } from './BookingConfirmationSummary';

interface BookingConfirmationModalProps {
  onClose: () => void;
  onSubmit: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  formState: InsuranceFormState;
  submissionStatus: InsuranceFormSubmissionStatus
}

export const BookingConfirmationModal: FC<BookingConfirmationModalProps> = (props) => {
  const { isOpen, onClose, onSubmit, submissionStatus, formState, setIsOpen } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabeledBy="bookingConfirmation-header"
      className="bookingConfirmation"
    >
      <BookingConfirmationSummary status={submissionStatus} formState={formState} />
      <BookingConfirmationControls
        onCancel={onClose}
        onAccept={onSubmit}
        status={submissionStatus}
      /> 
    </Modal>
  )
};
